import React from 'react';
import TablePagination from '../../../commonComponents/Pagination';

interface ListPaginationProps {
  totalCount: number;
  currentPage: number;
  pageSize: number;
  onChange: (page: number, pageSize: number) => void;
  totalLabel: string;
  /** Hidden entirely when the current page is empty, as every list here does. */
  visible: boolean;
}

/** `TablePagination` with the spacing every list in this feature uses. */
const ListPagination: React.FC<ListPaginationProps> = ({
  totalCount,
  currentPage,
  pageSize,
  onChange,
  totalLabel,
  visible,
}) => {
  if (!visible) return null;

  return (
    <TablePagination
      totalCount={totalCount}
      currentPage={currentPage}
      pageSize={pageSize}
      onChange={onChange}
      totalLabel={totalLabel}
      padding="16px 12px 0px 12px"
    />
  );
};

export default React.memo(ListPagination);
